import errorIcon from 'assets/icons/icon-error.svg';
import tickIcon from 'assets/icons/tick.svg';
import React, { Fragment, useContext } from 'react';
import { Button, Card, LocaleContext } from 'shared';

import { getEnvironmentVar } from '../../../../utils';

import { GeneralRedirectUrl, GeneralTitle, LogoStatusWrapper } from './General.styles';
import { GeneralProps } from './General.types';

export const General = ({ name, description, redirectUris, onEdit, logoStatus, logoEncoded }: GeneralProps) => {
  const localeContext = useContext(LocaleContext);
  const handleEdit = onEdit ? () => onEdit() : undefined;
  const isLogoEnabled = getEnvironmentVar('REACT_APP_LOGO_ENABLED') === 'true';

  const LogoVerified = () => {
    return (
      <LogoStatusWrapper>
        <div className="application-general__logo-status">
          <div>{localeContext.formatMessage({ id: 'APPLICATION-GENERAL.VERIFIED' })} </div>
          <img
            className="application-general__verified-icon"
            src={tickIcon}
            alt={localeContext.formatMessage({ id: 'APPLICATION-GENERAL.VERIFIED' })}
          />
        </div>
      </LogoStatusWrapper>
    );
  };

  const LogoRejected = () => {
    return (
      <LogoStatusWrapper>
        <div className="application-general__logo-error-status">
          <div>{localeContext.formatMessage({ id: 'APPLICATION-GENERAL.REJECTED' })} </div>
          <img
            className="application-general__error-icon"
            src={errorIcon}
            alt={localeContext.formatMessage({ id: 'APPLICATION-GENERAL.REJECTED' })}
          />
        </div>
      </LogoStatusWrapper>
    );
  };

  const LogoNotProvided = () => {
    return <div>{localeContext.formatMessage({ id: 'APPLICATION-GENERAL.NOT-PROVIDED' })}</div>;
  };

  const LogoPending = () => {
    return <div>{localeContext.formatMessage({ id: 'APPLICATION-GENERAL.NOT-VERIFIED' })}</div>;
  };
  const LOGO_STATUS_DESCRIPTION = {
    NOT_PROVIDED: <LogoNotProvided />,
    PENDING: <LogoPending />,
    REJECTED: <LogoRejected />,
    VERIFIED: <LogoVerified />,
  };

  const LogoItemWrapper = () => {
    return isLogoEnabled ? (
      <Card.Item>
        <Card.ItemKey>{localeContext.formatMessage({ id: 'APPLICATION-GENERAL.TPP-LOGO' })}:</Card.ItemKey>
        <Card.ItemValue>
          {logoEncoded != null ? (
            <Fragment>
              <img src={`data:image/png;base64,${logoEncoded}`} alt="tpp-logo" width={200} />
              {LOGO_STATUS_DESCRIPTION[logoStatus]}
            </Fragment>
          ) : (
            LOGO_STATUS_DESCRIPTION[logoStatus]
          )}
        </Card.ItemValue>
      </Card.Item>
    ) : (
      <div />
    );
  };

  return (
    <Card className="application-card application-general">
      <Card.Header className="application-general__header">
        <Card.Title className="application-general__title">
          {localeContext.formatMessage({ id: 'APPLICATION-GENERAL.TITLE' })}:
        </Card.Title>
        {handleEdit && (
          <Button
            type={'portal-lite'}
            icon={['1.25rem', 'pencilBlueIcon']}
            iconAfterText={true}
            onClick={handleEdit}
            className="button--application-edit"
          >
            {localeContext.formatMessage({ id: 'APPLICATION-GENERAL.EDIT-SECTION' })}
          </Button>
        )}
      </Card.Header>
      <Card.Body className="application-general__body">
        <Card.Item className="application-general__name">
          <Card.ItemKey className="application-general__key">
            {localeContext.formatMessage({ id: 'APPLICATION-GENERAL.ITEMS.TITLE' })}:
          </Card.ItemKey>
          <Card.ItemValue className="application-general__value application-general__name">
            <GeneralTitle>{name}</GeneralTitle>
          </Card.ItemValue>
        </Card.Item>
        <Card.Item className="application-general__description">
          <Card.ItemKey className="application-general__key">
            {localeContext.formatMessage({ id: 'APPLICATION-GENERAL.ITEMS.DESCRIPTION' })}:
          </Card.ItemKey>
          <Card.ItemValue className="application-general__value">{description}</Card.ItemValue>
        </Card.Item>
        <Card.Item className="application-general__redirect-urls">
          <Card.ItemKey className="application-general__key">
            {localeContext.formatMessage({ id: 'APPLICATION-GENERAL.ITEMS.REDIRECT-URLS' })}:
          </Card.ItemKey>
          <Card.ItemValue className="application-general__value">
            {redirectUris.map(url => (
              <GeneralRedirectUrl key={url}>{url}</GeneralRedirectUrl>
            ))}
          </Card.ItemValue>
        </Card.Item>
        <LogoItemWrapper />
      </Card.Body>
    </Card>
  );
};
